import { useState } from "react";
import PageHead from "@/components/common/PageHead";
import { Divider } from "@mantine/core";
import { Add1Icon } from "@form/components/common/icons";

import MenuLayout from "@/components/common/MenuLayout";
import Guide from "@/components/analyze/Guide";
import Link from "next/link";
import { getRoute } from "@/services/config";
import { isMaintenance } from "@/config/config";

import type { NextPage } from "next";

const Analytics: NextPage = () => {
  return (
    <MenuLayout>
      <PageHead></PageHead>
      <div className="px-5 sm:px-[7vw]">
        <div
          className={`max-w-[1100px] mx-auto mt-6 ${
            isMaintenance ? "sm:mt-8" : "sm:mt-14"
          } px-5 md:px-0 flex items-center justify-between flex-wrap`}
        >
          <div>
            <div className="text-header font-bold text-dark1">
              Analytic reports
            </div>
            <div className="text-body text-gray_58 mt-1">
              Reports that you previously created
            </div>
          </div>
          <div className="flex items-center">
            <Link href={getRoute("analytics_create").route}>
              <div className="flex items-center h-10 w-36 justify-center  bg-primary rounded-full ml-2 hover:cursor-pointer hover:bg-primary/80">
                <Add1Icon className="fill-white w-5"></Add1Icon>
                <div className="text-white font-semibold ml-2">Create new</div>
              </div>
            </Link>
          </div>
        </div>
        <Divider className="border-gray2  my-6"></Divider>
        <div className="flex items-center justify-center mt-[10vh]">
          <Guide></Guide>
        </div>
      </div>
    </MenuLayout>
  );
};

export default Analytics;
